export default {
  signInToYourAccount: "One-Time Password",
  emailAddress: "A One-Time Password has been sent to",
  backTo: "Back To",
  signIn: "Sign in",
};
